module.exports = __webpack_public_path__ + "static/sales-8d06e3036b17c7d79872c662a79ac2b0.png";